import * as React from 'react'
import { memo, useEffect, useLayoutEffect, useRef, useState } from 'react'

import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { ContributionType } from '../../store/contributions/contributionsTypings'

import { switchOpenedFromProfile } from '../../store/contributions/contributionsSlice'
import { removeFavoritesContribution } from '../../api/contributions'
import { fetchFavoriteContributionsList } from '../../store/member/memberSlice'
import { addUrlToArray } from '../../store/common/commonSlice'
import { RootState } from '../../store/rootReducer'
import { BackButtonType } from '../../store/common/commonSliceTyping'
import './styles.sass'
import { isUserPro } from '../../utils/isUserPro'

interface Props {
    profile?: boolean
    contribution: ContributionType
    fromTags?: boolean
    index?: number
    tag?: string
    currentPage?: number
    favorite?: boolean
    activePage?: number
    isAgeVerified?: boolean
}

const ContributionItem: React.FunctionComponent<Props> = ({
    contribution,
    profile = false,
    fromTags = false,
    index = null,
    tag,
    currentPage = 0,
    favorite = false,
    activePage,
    isAgeVerified
}: Props) => {
    const ref = useRef(null)
    const dispatch = useDispatch()
    const location = useLocation()

    const backButton = useSelector<RootState, BackButtonType>((state) => state.common.backButton)
    const user = useSelector((state: RootState) => state.member.user)
    const loggedIn = useSelector((state: RootState) => state.member.loggedIn)

    const descriptionRef = useRef(null)

    useLayoutEffect(() => {
        if (typeof document === 'object' && contribution.thumbnail_width) {
            const grid = document.getElementsByClassName('grid')[0]
            if (grid) {
                const gridColumnWidth = window
                    .getComputedStyle(grid)
                    .getPropertyValue('grid-template-columns')
                    .toString()
                    .split(' ')
                    .pop()
                    .split('px')
                    .shift()

                const imgWidth = Number(gridColumnWidth)
                const widthRation = imgWidth / Number(contribution.thumbnail_width)
                const imgHeight = Math.floor(Number(contribution.thumbnail_height) * widthRation)
                ref.current.height = imgHeight
            }
        }
    }, [])

    useEffect(() => {
        if (typeof window !== 'undefined') descriptionRef.current.style.transition = '600ms'
    }, [])

    return (
        <>
            <Link
                className="contributionMaterial"
                to={
                    isAgeVerified
                        ? {
                              state: { profile: profile },
                              pathname: contribution.url,
                              search: `${tag ? '?index=' + (+index + 1 + currentPage * 52) + '&tag=' + tag : ''}`
                          }
                        : {
                              pathname: ''
                          }
                }
                onClick={() => {
                    dispatch(switchOpenedFromProfile(fromTags && tag ? 'tags' : 'index'))
                    if (favorite) {
                        dispatch(switchOpenedFromProfile('favourites'))
                        if (!backButton.urlList.includes(location.pathname)) dispatch(addUrlToArray(location.pathname))
                    }
                }}
            >
                <div className={'contributionPreview_imgWrapper'} tabIndex={-1} data-descr={contribution.title}>
                    <div className={'contributionPreview_contribution_description'} ref={descriptionRef}>
                        <p className={'contributionPreview_contributionTitle'}>{contribution.title}</p>
                        {contribution.description_stripped ? (
                            <span className={'contributionPreview_contributionDescription'}>
                                {contribution.description_stripped}
                            </span>
                        ) : (
                            <></>
                        )}
                        <div className="contributionPreview_description">
                            <span
                                className={`contributionPreview_gender contributionPreview_gender_${contribution.user.gender}`}
                            >
                                <p className="contributionPreview_nick">{contribution.user.nick}</p>
                            </span>
                            <p>
                                {contribution.user.country && (
                                    <span className="contributionPreview_location">
                                        {contribution.user.country}
                                        {contribution.user.region && `, ${contribution.user.region}`}
                                    </span>
                                )}
                            </p>
                        </div>
                    </div>
                    <img
                        className={
                            (!loggedIn && contribution.pro === 1) ||
                            (user &&
                                !isUserPro(user.member_type) &&
                                contribution.pro === 1 &&
                                !(user && user.id === contribution.user.id))
                                ? 'onlyForPro'
                                : favorite
                                ? 'favoriteContributionImg'
                                : ''
                        }
                        ref={ref}
                        src={contribution.thumbnail}
                        alt={contribution.title}
                        onError={() => {
                            ref.current.src = require('./../../assets/404.png')
                            if (typeof document === 'object') ref.current.removeAttribute('height')
                        }}
                    />
                    {favorite && (
                        <img
                            src={require('./../../assets/ic-close.svg')}
                            className={'deleteFavoriteContribution'}
                            onClick={(e) => {
                                e.preventDefault()
                                removeFavoritesContribution({ id: contribution.id })
                                    .then(() => dispatch(fetchFavoriteContributionsList({ p: activePage })))
                                    .catch((e) => console.log(e))
                            }}
                        />
                    )}
                </div>
            </Link>
        </>
    )
}

export default memo(ContributionItem)
